import { Component, OnInit, HostBinding, Input, NgZone, AfterViewInit, ViewChild, ElementRef, Output, EventEmitter, TemplateRef, ChangeDetectorRef, Optional, Inject, LOCALE_ID } from '@angular/core';
import { PerformerOptions } from '../../entities/performer-options';
import { ProcessDesignerUIState } from '../../../../app/process-designer.uistate';
import { ExpressionService, InjectedType, ExprEditMode } from '@gsp-svc/expression';
import { MessagerService } from '@farris/ui-messager';
import { TypeConverter } from '@farris/ide-property-panel';
import { WF_LANG_RESOURCES, WfLocalePipe } from '../../../../i18n/pipe/wf-process-editor-locale.pipe';
import { WF_PROCESS_EDITOR_LANG_RESOURCES } from '../../../../i18n/assets/lang.resource';

@Component({
  selector: 'app-performer-options',
  templateUrl: './performer-options.component.html',
  styleUrls: ['./performer-options.component.scss'],
  providers: [
     WfLocalePipe,
  ]
})
export class PerformerOptionsComponent implements OnInit, AfterViewInit {
  @HostBinding('class')
  cls = 'farris-main-area flex-column';
  @Input() editorParams: any = {};
  @Output() closeModal = new EventEmitter<any>();
  @Output() submitModal = new EventEmitter<any>();
  @ViewChild('iconSelectFooter') modalFooter: TemplateRef<any>;
  performerOptionsLocation = '';
  @Input()
  set value(options: PerformerOptions) {
    if (options) {
      this.exclusionPerformers = options.ExclusionPerformers;
      this.noPerformerStrategy = options.NoPerformerStrategy;
      this.historicFirst = options.HistoricFirst;
      this.automaticPerformers = options.automaticPerformers;
    }
  }

  @Input()
  set exclusionPerformers(e: string | Array<string>) {
    if (e) {
      if (typeof e === 'string') {
        this.excludeProcInstCreator = e.indexOf('procInstCreator') > -1;
        this.excludePreActExecutors = e.indexOf('preActExecutors') > -1;
      } else {
        this.excludeProcInstCreator = e.findIndex(i => i === 'procInstCreator') > -1;
        this.excludePreActExecutors = e.findIndex(i => i === 'preActExecutors') > -1;
        this.excludeAllPassExecutors = e.findIndex(i => i === 'allPassExecutors') > -1;
        this.excludeExprPerformer = e.find(i => i.indexOf('expr') > -1);
        if (this.excludeExprPerformer != null && (this.excludeExprPerformer.startsWith('Sys#') ||
          this.excludeExprPerformer.startsWith('Administrative_staff#'))) {
          const excludeValue = this.excludeExprPerformer.split("#");
          this.exprPerformerType = excludeValue[0];
          this.excludeExprPerformer = excludeValue[1];
        }
      }
    }
  }

  set automaticPerformers(e: Array<string>) {
    if (e && e.length > 0) {
      this.autoProcInstCreator = e.findIndex(i => i === 'procInstCreator') > -1;
      this.autoPreActExecutors = e.findIndex(i => i === 'preActExecutors') > -1;
      this.autoAllPassExecutors = e.findIndex(i => i === 'allPassExecutors') > -1;
    }

  }

  @ViewChild('inputGroup') inputGroup: ElementRef;
  showClearButton = false;

  historicFirst = false;

  excludeExprPerformer: string;


  excludeProcInstCreator = false;
  excludePreActExecutors = false;
  excludeAllPassExecutors = false;

  autoProcInstCreator = false;
  autoPreActExecutors = false;
  autoAllPassExecutors = false;

  noPerformerStrategyList = [
    { text: this.localePipe.transform('component.performerOptions.leave'), value: 'leave' },
    { text: this.localePipe.transform('component.performerOptions.throwException'), value: 'throwException' }];
  variableOrgTypes = [
    { name: this.localePipe.transform('component.performerOptions.sys'), value: 'Sys' },
    { name: this.localePipe.transform('component.performerOptions.administrative_staff'), value: 'Administrative_staff' },
  ];
  exclusionPerformersOptions = [
    { value: 'procInstCreator', name: this.localePipe.transform('component.performerOptions.procInstCreator') },
    { value: 'preActExecutors', name: this.localePipe.transform('component.performerOptions.preActExecutors') },
    { value: 'allPassExecutors', name: this.localePipe.transform('component.performerOptions.allPassExecutors') }
  ];
  exprPerformerType = this.variableOrgTypes[0].value;
  noPerformerStrategy: string = this.noPerformerStrategyList[0].value;


  modalConfig = {
    title: this.localePipe.transform('component.performerOptions.performerOptions'),
    width: 760,
    height: 606,
    showButtons: true
  };

  constructor(
    private ngZone: NgZone,
    private designerState: ProcessDesignerUIState,
    private expr: ExpressionService,
    private message: MessagerService,
    @Optional() private cdr: ChangeDetectorRef,
    @Inject(LOCALE_ID) private localeId: string,
    @Inject(WF_LANG_RESOURCES) private resources: any,
    @Optional() private localePipe: WfLocalePipe,
  ) {
    this.localePipe = this.localePipe || new WfLocalePipe(localeId, resources);
   }

  ngOnInit() {
    this.performerOptionsLocation = this.editorParams.location;
  }

  ngAfterViewInit(): void {
    this.ngZone.runOutsideAngular(() => {
      this.inputGroup.nativeElement.addEventListener(
        'mouseenter',
        this.onMouseEnter.bind(this)
      );
      this.inputGroup.nativeElement.addEventListener(
        'mouseleave',
        this.onMouseLeave.bind(this)
      );
    });
  }

  onMouseEnter(event) {
    this.showClearButton = true;
    if (this.showClearButton) {
      this.toggleClearIcon(event, true);
    }
  }
  onMouseLeave(event) {
    this.showClearButton = false;
    this.toggleClearIcon(event, false);
  }
  private toggleClearIcon(event: any, isShow = false) {
    const str = isShow ? '' : 'none';
    const clearIcon = event.target.querySelector('.input-group-clear');
    if (clearIcon) {
      clearIcon.style.display = str;
    }
  }


  clickOK() {
    const options = {
      ExclusionPerformers: this.getExclusionPerformers(),
      NoPerformerStrategy: this.noPerformerStrategy,
      HistoricFirst: this.historicFirst,
      automaticPerformers: this.getAutoPerformers()
    };
    const object = {
      value: options, parameters: null
    };
    this.submitModal.emit(object);
  }

  cancel() {
    this.closeModal.emit();
  }

  excludeProcInstCreatorClick(event: any) {
    // this.excludeProcInstCreator = !this.excludeProcInstCreator;
    if (this.excludeProcInstCreator && this.autoProcInstCreator) {
      this.autoProcInstCreator = false;
    }
  }

  excludePreActExecutorsClick(event: any) {
    // this.excludePreActExecutors = !this.excludePreActExecutors;
    if (this.autoAllPassExecutors === true && this.excludePreActExecutors === true) {
      this.message.info(this.localePipe.transform('component.performerOptions.exclusionNotAllowed'), () => {
        this.excludePreActExecutors = false;
      });
      return;
    }
    if (this.excludePreActExecutors && this.autoPreActExecutors) {
      this.autoPreActExecutors = false;
    }
  }

  excludeAllPassExecutorsClick(event: any) {
    // this.excludeAllPassExecutors = !this.excludeAllPassExecutors;
    if (this.excludeAllPassExecutors) {
      if (this.autoPreActExecutors) {
        this.autoPreActExecutors = false;
      }
      if (this.autoAllPassExecutors) {
        this.autoAllPassExecutors = false;
      }
    }

  }

  autoProcInstCreatorClick(event: any) {
    // if (this.designerState.propertyData.CompleteStrategy !== this.designerState.completeIterator[0].key
    //   && this.autoProcInstCreator === true ) {
    //   this.message.info('【完成策略】为【会签】时，不允许设置自动审批，请了解！', () => {
    //     this.autoProcInstCreator = false;
    //   });
    //   return;
    // }
    if (this.designerState.propertyData.AssignStrategy === this.designerState.assignIterator[2].key
      && this.autoProcInstCreator === true ) {
      this.message.info(this.localePipe.transform('component.performerOptions.approvalNotAllowedAsSet'), () => {
        this.autoProcInstCreator = false;
      });
      return;
    }
    // this.autoProcInstCreator = !this.autoProcInstCreator;
    if (this.autoProcInstCreator && this.excludeProcInstCreator) {
      this.excludeProcInstCreator = false;
    }
  }

  autoPreActExecutorsClick(event: any) {
    // if (this.designerState.propertyData.CompleteStrategy !== this.designerState.completeIterator[0].key
    //   && this.autoPreActExecutors === true) {
    //   this.message.info('【完成策略】为【会签】时，不允许设置自动审批，请了解！', () => {
    //     this.autoPreActExecutors = false;
    //   });
    //   return;
    // }
    if (this.designerState.propertyData.AssignStrategy === this.designerState.assignIterator[2].key
      && this.autoPreActExecutors === true) {
      this.message.info(this.localePipe.transform('component.performerOptions.approvalNotAllowed'), () => {
        this.autoPreActExecutors = false;
      });
      return;
    }
    if (this.excludeAllPassExecutors === true && this.autoPreActExecutors === true) {
      this.message.info(this.localePipe.transform('component.performerOptions.approvalNotAllowedAsSet'), () => {
        this.autoPreActExecutors = false;
      });
      return;
    }
    // this.autoPreActExecutors = !this.autoPreActExecutors;
    if (this.autoPreActExecutors && this.excludePreActExecutors) {
      this.excludePreActExecutors = false;
    }
  }

  autoAllPassExecutorsClick(event: any) {
    // if (this.designerState.propertyData.CompleteStrategy !== this.designerState.completeIterator[0].key
    //   && this.autoAllPassExecutors === true) {
    //   this.message.info('【完成策略】为【会签】时，不允许设置自动审批，请了解！', () => {
    //     this.autoAllPassExecutors = false;
    //   });
    //   return;
    // }
    if (this.designerState.propertyData.AssignStrategy === this.designerState.assignIterator[2].key
      && this.autoAllPassExecutors === true) {
      this.message.info(this.localePipe.transform('component.performerOptions.allocationStrategyIsCollect'), () => {
        this.autoAllPassExecutors = false;
      });
      return;
    }
    // this.autoAllPassExecutors = !this.autoAllPassExecutors;
    if (this.autoAllPassExecutors) {
      if (this.excludeAllPassExecutors) {
        this.excludeAllPassExecutors = false;
      }
      if (this.excludePreActExecutors) {
        this.excludePreActExecutors = false;
      }
    }
  }

  getPerformerOptions(): PerformerOptions {
    return {
      ExclusionPerformers: this.getExclusionPerformers(),
      NoPerformerStrategy: this.noPerformerStrategy,
      HistoricFirst: this.historicFirst,
      automaticPerformers: this.getAutoPerformers()
    };
  }
  private getExclusionPerformers(): string[] {
    const exclusionPerf: Array<string> = [];
    if (this.excludeProcInstCreator) {
      exclusionPerf.push('procInstCreator');
    }
    if (this.excludePreActExecutors) {
      exclusionPerf.push('preActExecutors');
    }
    if (this.excludeAllPassExecutors) {
      exclusionPerf.push('allPassExecutors');
    }
    if (this.excludeExprPerformer) {
      exclusionPerf.push(`${this.exprPerformerType}#${this.excludeExprPerformer}`);
    }

    return exclusionPerf;
  }

  private getAutoPerformers(): Array<string> {
    const autoPerf: Array<string> = new Array();
    if (this.autoProcInstCreator) {
      autoPerf.push('procInstCreator');
    }
    if (this.autoPreActExecutors) {
      autoPerf.push('preActExecutors');
    }
    if (this.autoAllPassExecutors) {
      autoPerf.push('allPassExecutors');
    }

    return autoPerf;
  }

  openExprEditor() {
    // this.expr.clearContext();
    this.expr.setEditPattern(ExprEditMode.Advanced);
    if (this.designerState.schemas.length > 0) {
      for (const schema of this.designerState.schemas) {
        this.expr.addSchema('Schema', schema);
      }
      if (this.designerState.schemas[0].entityTypes && this.designerState.schemas[0].entityTypes.length > 0) {
        const entityType = this.designerState.schemas[0].entityTypes[0];
        this.expr.addInjectedEntity(entityType.name, 'Schema',
          entityType.name, InjectedType.EntityType);
      }
    }
    let context = new Array();
    context = this.designerState.addContext(context);
    if (this.designerState.subActivityContext.length > 0) {
      for (const variable of this.designerState.subActivityContext) {
        if (!context.some(c => c.key === variable.key)) {
          context.push(variable);
        }
        // this.expr.addContext(variable);
      }
    }
    if (context.length > 0) {
      for (const v of context) {
        this.expr.addContext(v);
      }
    }
    // if (this.excludeExprPerformer) {
    this.expr.addExpressionText(this.excludeExprPerformer);
    // }
    this.expr.buildExpression().then((d: string) => {
      this.excludeExprPerformer = d;
      //点击确定后，去除表达式里面的新增的上下文变量
      if(context.length > 0) {
        this.expr.exprEntity.contextEntities = this.expr.exprEntity.contextEntities.filter(x => !context.some(y => y.key === x.key));
      }
    });
  }
  orgTypeChange(data: any) {
    if (data === 'Sys') {
      this.exprPerformerType = this.variableOrgTypes[0].value;
    } else if (data === 'Administrative_staff') {
      this.exprPerformerType = this.variableOrgTypes[1].value;
    }
  }
  clear() {
    this.excludeExprPerformer = '';
  }

}

export class PerformerOptionsConverter implements TypeConverter {
  constructor(
    private localePipe: WfLocalePipe
  ) { }

  convertTo(data: any[]): string {
    return this.localePipe.transform("component.performerOptions.set");
  }
}
